// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { FundingRateMarkupPlan } from './FundingRateMarkupPlan';
export class FundingRateMarkupPlans {
    constructor() {
        this.UpdateEvent = new CustomEvent();
        this._fFundingRateMarkupPlans = {};
    }
    GetPlanById(id) {
        return this._fFundingRateMarkupPlans[id] || null;
    }
    Add(message) {
        let plan = this.GetPlanById(message.Id);
        if (!plan) {
            plan = this._fFundingRateMarkupPlans[message.Id] = new FundingRateMarkupPlan(message.Id);
        }
        plan.Update(message);
        this.UpdateEvent.Raise(plan);
    }
    Clear() {
        this._fFundingRateMarkupPlans = {};
    }
    GetDataByInstrument(planId, instr) {
        if (instr === null || planId === null) {
            return null;
        }
        const plan = this.GetPlanById(planId);
        return plan != null ? plan.GetData(instr) : null;
    }
    GetSpreadedFundingRateValue(acc, ins, fundingRateValue) {
        const data = acc ? this.GetDataByInstrument(acc.FundingRatesPlanId, ins) : null;
        return FundingRateMarkupPlans.GetSpreadedFundingRateValueByPlanData(data, fundingRateValue);
    }
    static GetSpreadedFundingRateValueByPlanData(planData, fundingRateValue) {
        if (planData) {
            switch (planData.MarkupType) {
                case FundingRateMarkupPlanTypes.FIXED_PERCENT:
                    return fundingRateValue * 100 + planData.MarkupValue;
                case FundingRateMarkupPlanTypes.PERCENT_FROM_FUNDING_RATE:
                    return fundingRateValue * 100 + (planData.MarkupValue / 100) * fundingRateValue * 100;
            }
        }
        return fundingRateValue;
    }
}
export var FundingRateMarkupPlanTypes;
(function (FundingRateMarkupPlanTypes) {
    FundingRateMarkupPlanTypes[FundingRateMarkupPlanTypes["FIXED_PERCENT"] = 0] = "FIXED_PERCENT";
    FundingRateMarkupPlanTypes[FundingRateMarkupPlanTypes["PERCENT_FROM_FUNDING_RATE"] = 1] = "PERCENT_FROM_FUNDING_RATE";
})(FundingRateMarkupPlanTypes || (FundingRateMarkupPlanTypes = {}));
